
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4.5A11.336 11.336 0 0 0 .75 15.923V18a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-2.08A11.336 11.336 0 0 0 12 4.5Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9 19.5v-.75a3 3 0 0 1 6 0v.75m-.75-10.497L12 15.753m-7.125-.75h0m0-.003a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m1.5-3.747h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m12.75 3.75h0m0-.003a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-1.5-3.747h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-8.25-3h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    